import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { RegistrationNavigationState } from 'utils/registrationNavigation';

import { useAuth } from '.';

const RequireAuth = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  const { pathname, search, hash } = useLocation();

  if (user?.isSuspended) {
    return <Navigate to={{ pathname: '/suspended', search }} replace />;
  }

  if (!user?.isMember && !user?.isNormal) {
    const state: RegistrationNavigationState = {
      returnTo: { pathname, search, hash },
    };
    return (
      <Navigate to={{ pathname: '/benefit', search }} state={state} replace />
    );
  }

  return children;
};
export default RequireAuth;
